import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/landing';

/**
 * learning.nirvik.ai router scaffold.
 *
 * Only `/` is wired up today — future routes (tracks, lessons, educators,
 * community, cohorts) slot in here as curriculum ships. */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
    </Routes>
  );
}
